import { render, staticRenderFns } from "./BrandingSelection.vue?vue&type=template&id=05af2dc6&scoped=true"
import script from "./BrandingSelection.vue?vue&type=script&lang=js"
export * from "./BrandingSelection.vue?vue&type=script&lang=js"
import style0 from "./BrandingSelection.vue?vue&type=style&index=0&id=05af2dc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05af2dc6",
  null
  
)

export default component.exports